import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard as ReactCopyToClipboard } from 'react-copy-to-clipboard';
import { MdContentCopy } from 'react-icons/md';
import classnames from 'classnames/bind';
import styles from './CopyToClipboard.module.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cln = classnames.bind(styles);
export default function CopyToClipboard({
  title = 'Click to copy',
  text,
  className,
  onClick,
  onCopy,
  onCopyMessage,
  label,
  children
}) {
  const [isCopied, setIsCopied] = useState();
  const copiedTimeout = useRef(null);
  const handleCopy = (copiedText, result) => {
    if (onCopy) {
      onCopy(copiedText, result);
    }
    if (!onCopyMessage) {
      return;
    }
    clearTimeout(copiedTimeout.current);
    setIsCopied(true);
    copiedTimeout.current = setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };
  return /*#__PURE__*/_jsx(ReactCopyToClipboard, {
    text: text,
    onCopy: handleCopy,
    children: children || /*#__PURE__*/_jsxs("span", {
      title: title,
      className: cln('CopyToClipboard', className, {
        'CopyToClipboard--copied': isCopied
      }),
      onClick: onClick,
      children: [(isCopied ? onCopyMessage : label) || text, (!isCopied || !onCopyMessage) && /*#__PURE__*/_jsx(MdContentCopy, {})]
    })
  });
}
CopyToClipboard.propTypes = {
  /** Text which will be copied to clipboard */
  text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * Title displayed on hover<br/>
   * <em>Notice: this property is omitted when children provided</em>
   */
  title: PropTypes.string,
  /**
   * Optional className to customize the container<br/>
   * <em>Notice: this property is omitted when children provided</em>
   */
  className: PropTypes.string,
  /**
   * Alternate text displayed as label<br/>
   * <em>Notice: this property is omitted when children provided</em>
   */
  label: PropTypes.string,
  /**
   * Optional message displayed after copying text to clipboard<br/>
   * <em>Notice: this property is omitted when children provided</em>
   */
  onCopyMessage: PropTypes.string,
  /**
   * Optional function called after clicking the label<br/>
   * <em>Notice: this property is omitted when children provided</em>
   * @param {SyntheticEvent} event
   */
  onClick: PropTypes.func,
  /**
   * Optional function called after copying text to clipboard
   * @param {string} text - returns a value of a copied text<br/>
   * @param {boolean} result - returns `true` if copied successfully, else `false`.
   */
  onCopy: PropTypes.func,
  /** Optional custom node that will be displayed instead of label */
  children: PropTypes.node
};